
























































































































































































































































































































































































































































import {
  Component,
  Vue,
  Watch,
} from 'vue-property-decorator';
import ConnectivityService, { LoRaCredentials } from '@/services/connectivity.service';
import {Action, Getter} from 'vuex-class';
import {LoRaNetworkServer, SigfoxApiCredentials} from '@/types';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import GenericButton from '@/components/GenericButton.vue';


export enum LNS {
  KERLINK = 'kerlink',
  THE_THINGS_INDUSTRY = 'theThingsIndustry',
  THE_THINGS_NETWORK = 'theThingsNetwork',
  IOT_SCOTLAND_OLD = 'boston-iot.net',
  IOT_SCOTLAND = 'north.loriot.io',
  ALLIOT_WANESY = 'alliot.wanesy.com',
  NETMORE = 'api.blink.services',
  LORIOT_MANAGED = 'loriot_managed',
  THINGPARK = 'actility-thingpark',
}

@Component({
  components: {GenericButton, ConfirmButton, CancelButton, Dialog},
})
export default class LoraSettings extends Vue {
  @Action private getGatewaySettingsAsync: any;

  private get applicationServer() {
    return this.tenant && this.tenant.length ? `${this.tenant}.${this.applicationServerUrl}` : this.applicationServerUrl;
  }

  private get requiredRules() {
    return {
      username: [
        (v: string) => !!v || `Username can't be empty`,
        (v: string) => v && v.length >= 0 || `Username can't be empty`,
      ],
      password: [
        (v: string) => !!v || `Password can't be empty`,
        (v: string) => v && v.length > 0 || `Password can't be empty`,
      ],
      customerId: [
        (v: string) => !!v || `Customer ID  can't be empty`,
        (v: string) => v && v.length > 0 || `Customer ID  can't be empty`,
        (v: string) => !isNaN(Number(v)) || `Customer ID must be a number`,
      ],
      clientSecret: [
        (v: string) => !!v || `Client Secret can't be empty`,
        (v: string) => v && v.length > 0 || `Client Secret  can't be empty`,
      ],
      clientId: [
        (v: string) => !!v || `Client ID can't be empty`,
        (v: string) => v && v.length > 0 || `Client ID  can't be empty`,
      ],
      clusterId: [
        (v: string) => (!v || (v && !isNaN(Number(v)))) || `Cluster ID must be a number`,
      ],
      applicationServer: [
        (v: string) => !!v || `Application server can't be empty `,
      ],
      cluster: [
        (v: string) => !!v || `Must select a cluster`,
      ],
      apiKey: [
        (v: string) => !!v || `API key can't be empty`,
        (v: string) => v && v.length > 0 || `API key can't be empty`,
      ],
      organisationId: [
        (v: string) => !!v || `Organisation ID can't be empty`,
        (v: string) => v && v.length > 0 || `Organisation ID can't be empty`,
      ],
      tenant: [
        (v: string) => !!v || `Tenant ID can't be empty`,
        (v: string) => v && v.length > 0 || `Tenant can't be empty`,
      ],
      serviceProviderCode: [
        (v: string) => !!v || `Service provider code can't be empty`,
        (v: string) => v && v.length > 0 || `Service provider code  can't be empty`,
      ],
    };
  }
  private lns: string = '';
  private id: number = 0;
  private dropdownDisabled: boolean = false;
  private saveButtonDisabled: boolean = true;
  private host: string = '';

  private isIotScotland: boolean = false;
  private snackbar: boolean = false;
  private isKerlinkWanesyThirdParty: boolean = false;
  private isTTSThirdParty: boolean = false;
  private isNetmore: boolean = false;
  private isThingPark: boolean = false;
  private isLoriotManaged: boolean = false;
  private servers: LoRaNetworkServer[] = [];
  private items: any[] = [];
  private username: string = '';
  private password: string = '';
  private applicationId: string = '';
  private organisationId: string = '';
  private applicationServerUrl: string = '';
  private tenant: string = '';
  private apiKey: string = '';
  private serviceProviderCode: string = '';
  private valid: boolean = false;
  private createWebhook: boolean = true;
  private customerId: string = '';
  private clusterId: string = '';
  // thingpark
  private clientSecret: string = '';
  private clientId: string = '';
  private domain: string = '';

  private loading: boolean = true;
  private hideKey: boolean = true;

  private removing: boolean = false;
  private removeDialog: boolean = false;
  private confirmRemoveDialog: boolean = false;
  private deleteConfirmText: string = '';

  private LoriotUrls: string[] = [
    'eu4pro.loriot.io',
    'eu1.loriot.io',
    'eu2.loriot.io',
    'eu3.loriot.io',
    'eu5pro.loriot.io',
    'uk1.loriot.io',
    'af1.loriot.io',
    'me1pro.loriot.io',
    'ap1.loriot.io',
    'ap2.loriot.io',
    'ap3.loriot.io',
    'ap4pro.loriot.io',
    'au1.loriot.io',
    'au2pro.loriot.io',
    'il1.loriot.io',
    'us1.loriot.io',
    'us2.loriot.io',
    'us3pro.loriot.io',
    'sa1.loriot.io',
    'sa2pro.loriot.io',
  ];
  private TTNUrls: string[] = [
    'eu1.cloud.thethings.network',
    'nam1.cloud.thethings.network',
    'au1.cloud.thethings.network',
  ];
  private TTIUrls: string[] = [
    'eu1.cloud.thethings.industries',
    'eu2.cloud.thethings.industries',
    'nam1.cloud.thethings.industries',
    'au1.cloud.thethings.industries',
  ];
  private thingsStackCloudEnabled = true;
  private privateLoriotServerEnabled = false;
  @Getter private hasPermission!: any;
  @Watch('lns')
  public onDataChanged(value: any) {
    const lns = this.lns.toLowerCase();
    if (!this.loading) {
      this.host = '';
    }
    this.createWebhook = true;

    this.isKerlinkWanesyThirdParty = false;
    this.isTTSThirdParty = false;
    this.isNetmore = false;
    this.isLoriotManaged = false;
    this.isIotScotland = false;
    this.isThingPark = false;
    if (lns === 'alliot wanesy') {
      this.isKerlinkWanesyThirdParty = true;
      this.host = 'alliot.wanesy.com';
    } else if (lns === 'the things industries' || lns === 'the things network') {
      this.isTTSThirdParty = true;
    } else if (lns === 'netmore') {
      this.isNetmore = true;
    } else if (lns === 'loriot' || lns === 'iot scotland') {
      this.isLoriotManaged = true;
      if (lns === 'iot scotland') {
        this.isIotScotland = true;
        this.host = 'north.loriot.io';
      }
    } else if (lns === 'actility thingpark' ) {
      this.isThingPark = true;
    }
    this.saveButtonDisabled = !lns.length || (lns !== 'iot scotland' && lns !== 'alliot wanesy' && lns !== 'the things industries' && lns !== 'the things network' && lns !== 'netmore' && lns !== 'thingpark' &&  !!this.id );
  }

  private get disabled() {
    if (this.isKerlinkWanesyThirdParty) {
      if (!this.username || !this.password || !this.customerId || !this.clusterId) {
        return true;
      }
    } else if (this.isTTSThirdParty) {
      if (!this.tenant || !this.apiKey || !this.organisationId || !this.applicationServerUrl) {
        return true;
      }
    } else if (this.isNetmore) {
      if (!this.username || !this.password || !this.serviceProviderCode) {
        return true;
      }
    } else if (this.isLoriotManaged) {
      if (!this.host || !this.apiKey) {
        return true;
      }
    } else if (this.isThingPark) {
      if (!this.host || !this.clientId || !this.clientSecret) {
        return true;
      }
    }
  }

  private toggleTTISwitch() {
    if (!this.id && this.applicationServerUrl.endsWith('cloud.thethings.industries')) {
      this.thingsStackCloudEnabled = false;
    } else if (!!this.id && !this.applicationServerUrl.endsWith('cloud.thethings.industries')) {
      this.thingsStackCloudEnabled = false;
    } else {
      this.thingsStackCloudEnabled = true;
    }
  }

  private toggleLoriotSwitch() {
    if (!this.isLoriotManaged) {
      return;
    }
    const isPublicServer = this.LoriotUrls.includes(this.host);

    if (this.id) {
      this.privateLoriotServerEnabled = !isPublicServer;
    } else if (!this.privateLoriotServerEnabled) {
      this.host = '';
    }
  }

  private async mounted() {
    await this.initForm();
    this.toggleTTISwitch();
    this.toggleLoriotSwitch();
  }

  private async initForm() {
    this.loading = true;
    try {
      const jobs: Array<Promise<any>> = [];
      jobs.push(ConnectivityService.getLoraSettings());
      jobs.push(ConnectivityService.getLoRaNetworkServers());
      const [creds, servers] = await Promise.all(jobs);
      this.servers = servers;
      this.items = this.servers.filter((s) => s.display === true).map((s) => ({ text: s.name, val: s.host }));

      if (creds) {
        const item: any = this.servers.find((l: any) => l.host === creds.lns);
        if (!item) {
          return;
        }
        const newLns = { text: item.name, val: item.host };
        if (this.items.filter((s) => s.val === newLns.val).length === 0) {
          this.items.push(newLns);
        }
        this.lns = item.name;
        this.id = creds.id;
        if ( creds.lns === 'boston-iot.net' || creds.lns === 'alliot.wanesy.com' ) {
          this.clusterId = creds.clusterId || '';
          this.customerId = creds.customerId || '';
          this.username = creds.username || '';
          this.password = creds.password || '';
          this.host = creds.lns;
        } else if ( creds.lns === 'theThingsIndustry' || creds.lns === 'theThingsNetwork') {
          const tenantIndex = creds.application_server!.indexOf('.') + 1;
          this.applicationServerUrl = creds.lns === 'theThingsIndustry' ? creds.application_server!.substring(tenantIndex) : creds.application_server || '';
          this.applicationId = creds.application_id || '';
          this.organisationId = creds.organisation_id || '';
          this.apiKey = creds.api_key || '';
          this.tenant = creds.application_server!.split('.')[0] || '';
        } else if ( creds.lns === LNS.NETMORE) {
          this.serviceProviderCode = creds.service_provider_code || '';
          this.username = creds.username || '';
          this.password = creds.password || '';
        } else if ( creds.lns === LNS.LORIOT_MANAGED) {
          this.host = creds.host || '';
          this.apiKey = creds.account_token || creds.api_key || '';
          this.applicationId = creds.application_id || '';
        } else if ( creds.lns === LNS.THINGPARK) {
          this.host = creds.network_server || '';
          this.clientId = creds.client_id || '';
          this.clientSecret = creds.client_secret || '';
          this.domain = creds.domain || '';
        }
        this.dropdownDisabled = true;
      } else {
        this.lns = '';
        this.id = 0;
      }
    } finally {
      await this.$nextTick();
      this.loading = false;
    }
  }

  private async removeCredentials() {
    if (!this.id) {
      this.username = '';
      this.password = '';
      this.applicationId = '';
      this.organisationId = '';
      this.applicationServerUrl = '';
      this.tenant = '';
      this.apiKey = '';
      this.serviceProviderCode = '';
      this.customerId = '';
      this.clusterId = '';
      this.host = '';
      this.clientId = '';
      this.clientSecret = '';
      this.domain = '';
      this.id = 0;
      this.lns = '';
      this.deleteConfirmText = '';
      await this.initForm();
      return;
    }
    this.removeDialog = true;
  }

  private confirmRemoval() {
    this.confirmRemoveDialog = true;
  }

  private async clearCredentials() {
    this.removing = true;
    try {
      await ConnectivityService.removeLoRaSettings(this.id);
    } finally {
      this.removing = false;
      this.confirmRemoveDialog = false;
      this.removeDialog = false;
      this.dropdownDisabled = false;
      await this.initForm();
    }
  }

  private async saveCredentials() {
    await this.$nextTick();

    if (this.$refs.form && ((this.$refs.form as Vue & { validate: () => boolean }).validate())) {
        this.saveButtonDisabled = true;
        this.dropdownDisabled = true;
        const item: any = this.items.find((l: any) => l.text === this.lns);

        try {
          if ( item.val === 'boston-iot.net') {
            const response = this.id
                ? await ConnectivityService.updateLoRaSettings(item.val, this.id, this.username, this.password)
                : await ConnectivityService.createIoTScotlandSettings(item.val, this.username, this.password, this.customerId, this.clusterId);
            this.id = response.id;
            this.saveButtonDisabled = false;
          } else if (item.val === 'theThingsIndustry' || item.val === 'theThingsNetwork') {
            const response = this.id ?
              await ConnectivityService.updateTTISettings(item.val,  this.apiKey)
              : await ConnectivityService.createLoRaTTSSettings(item.val, this.applicationServer, this.apiKey, this.organisationId, this.applicationId, this.createWebhook);
            this.id = this.id ? this.id : response.id;
            this.saveButtonDisabled = false;
          } else if (item.val === LNS.NETMORE) {
            const response = await ConnectivityService.createNetmoreSettings({ username: this.username, password: this.password, service_provider_code: this.serviceProviderCode });
            this.id = response.id;
          } else if (item.val === LNS.LORIOT_MANAGED || item.val === LNS.IOT_SCOTLAND)  {
            const response = await ConnectivityService.createLoriotSettings({ host: this.host, api_key: this.apiKey, application_id: this.applicationId, create_webhook: this.createWebhook });
            this.id = response.id;
          } else if (item.val === LNS.THINGPARK)  {
            const response = await ConnectivityService.createThingParkSettings({ network_server: this.host, client_id: this.clientId, client_secret: this.clientSecret, domain: this.domain, create_webhook: this.createWebhook });
            this.id = response.id;
          } else {
            const response = await ConnectivityService.createLoRaSetting(item.val);
            this.id = response.id;
          }

          this.getGatewaySettingsAsync();
          this.snackbar = true;
        } catch (e) {
          this.saveButtonDisabled = false;
          this.dropdownDisabled = false;
          throw e;
        }
    }
  }

  private isThirdParty(): boolean {
    const item = this.servers.find((l) => l.name === this.lns);
    return !!item && item.thirdParty;
  }
}
